import React from 'react';
import * as Yup from 'yup';
import {
  CrudMasterDetailView,
  GridView,
  Widget,
  FormInput,
  FormSwitch,
  MasterDetailForm,
  ButtonDelete,
  FormSubmitButton,
  FormatText,
  CrudContext,
  CompositeView,
  useRouter,
} from '@digital/ui';
import {
  getAllTiposDocumentoDeloitte,
  createTipoDocumentoDeloitte,
  updateTipoDocumentoDeloitte,
  deleteTipoDocumentoDeloitte,
} from '../../api/tipoDocumentoDeloitte';
import { hasPermission } from '@app/helpers/permissions';

const TipoDocumentoDeloitte = () => {
  const [GetAllItems, setGetAllItems] = React.useState(() => getAllTiposDocumentoDeloitte);
  const { history } = useRouter();

  const reload = () => {
    setGetAllItems(() => Promise.resolve(undefined));
    setGetAllItems(() => getAllTiposDocumentoDeloitte);
  };

  const onCreateItem = (values: any) =>
    createTipoDocumentoDeloitte(values).then(resp => {
      if (resp.valid) reload();
      return resp;
    });

  const onUpdateItem = (values: any) =>
    updateTipoDocumentoDeloitte(values).then(resp => {
      if (resp.valid) reload();
      return resp;
    });

  return (
    <CrudMasterDetailView
      getAllItems={GetAllItems}
      createItem={hasPermission(['PENDENCIA_DOCUMENTAL_EDITAR']) ? onCreateItem : undefined}
      updateItem={onUpdateItem}
      icon="commons-settings"
      titleExtractor={x => x.nomeDocumento}
      descriptionExtractor={x => (x.critico ? 'Crítico' : 'Não Crítico')}
      filterPredicate={(item, value) =>
        item.nomeDocumento.toLowerCase().includes(value.toLowerCase())
      }
      disableNotification>
      <CompositeView>
        <CrudContext.Consumer>
          {({ selectedItem }) => (
            <GridView noform>
              <MasterDetailForm
                validationSchema={Yup.object().shape({
                  nomeDocumento: Yup.string()
                    .required('Nome do documento é obrigatório')
                    .max(500, 'Máximo 500 caracteres'),
                })}>
                <Widget
                  title="Tipo de Documento Deloitte"
                  actions={[
                    selectedItem && hasPermission(['PENDENCIA_DOCUMENTAL_EDITAR']) && (
                      <ButtonDelete
                        icon={null}
                        type="danger"
                        confirm="Deseja realmente excluir este registro?"
                        okText="Confirmar"
                        onClick={() => {
                          deleteTipoDocumentoDeloitte(selectedItem.id).then(resp => {
                            if (resp.valid) {
                              reload();
                              history.push('/tiposDocumentoDeloitte');
                            }
                          });
                        }}
                      />
                    ),
                    hasPermission(['PENDENCIA_DOCUMENTAL_EDITAR']) && (
                      <FormSubmitButton noIcon={true} type="primary">
                        <FormatText id="ui.commons.save" uppercase />
                      </FormSubmitButton>
                    ),
                  ]}>
                  <FormInput label="Nome do Documento" name="nomeDocumento" span={8} />
                  <FormSwitch label="Crítico?" name="critico" span={4} />
                </Widget>
              </MasterDetailForm>
            </GridView>
          )}
        </CrudContext.Consumer>
      </CompositeView>
    </CrudMasterDetailView>
  );
};

export default TipoDocumentoDeloitte;
